// Servicio ApiDoo — autenticación y comunicación con el backend.
// El proxy en setupProxy.js redirige /api/* → backend en desarrollo.
// En producción el frontend se sirve desde el mismo servidor IIS.

const API_BASE = process.env.REACT_APP_API_BASE || '';

// Token vive solo en memoria: no persiste en localStorage para evitar XSS.
let _token   = null;
let _expiry  = 0;
let _usuario = '';

// Contexto de conversación: datos del paciente y sesión acumulados por el backend.
let _context = {};

/** Inicia sesión y almacena el token en memoria. */
export async function iniciarSesion(usuario, clave) {
  const res = await fetch(`${API_BASE}/api/auth/login`, {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ usuario, clave }),
  });
  const json = await res.json();
  if (!res.ok || !json.success) throw new Error(json.message || 'Credenciales incorrectas');

  const data = json.data;
  _token   = data.access_token;
  _expiry  = Date.now() + data.expires_in * 1000 - 60_000;
  _usuario = data.usuario;
}

/** Cierra sesión: limpia el token y el contexto de conversación. */
export function cerrarSesion() {
  _token   = null;
  _expiry  = 0;
  _usuario = '';
  _context = {};
}

/** Resetea el contexto de conversación (nueva conversación). */
export function resetearContexto() {
  _context = {};
}

/** Devuelve true si hay sesión válida en memoria. */
export function sesionActiva() {
  return Boolean(_token && Date.now() < _expiry);
}

/** Devuelve el nombre del usuario logueado. */
export function usuarioActual() {
  return _usuario;
}

/**
 * Envía el historial de conversación al backend.
 * El backend gestiona el loop tool_use con Claude internamente.
 * La API key nunca llega al navegador.
 *
 * @param {Array<{role: string, content: string}>} messages - historial completo
 * @returns {Promise<string>} texto de respuesta de Sofía
 */
export async function llamarClaude(messages) {
  if (!_token || Date.now() >= _expiry) throw new Error('Sesión expirada.');

  const res = await fetch(`${API_BASE}/api/claude/chat`, {
    method:  'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${_token}`,
    },
    body: JSON.stringify({ messages, context: _context }),
  });

  const json = await res.json();
  if (!res.ok || !json.success) throw new Error(json.message || `Error HTTP ${res.status}`);

  // Actualizar contexto acumulado con lo que devuelve el backend
  const data = json.data || {};
  if (data.context) _context = { ..._context, ...data.context };
  return data.text || data || '';
}
